import { CLEAR_GROUP } from '../actions/groups'

const group = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_GROUP:
      state = {}
      break
  }
  return state
}

export default group
